module.exports = __webpack_public_path__ + "img/report4.32df1cae.svg";